import { render, staticRenderFns } from "./eventReceptPage.vue?vue&type=template&id=cab68210&"
import script from "./eventReceptPage.vue?vue&type=script&lang=ts&"
export * from "./eventReceptPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports